import { palette } from "../../../styles/palette";

export const styles = {
  paper: {
    backgroundColor: palette.primaryWhite,
    borderRadius: 20,
  }
};
